
namespace SP {
    export class ChartElement {
       
    }
}